import {ActivatedRouteSnapshot, Resolve} from '@angular/router';
import {Injectable} from '@angular/core';
import {AppointmentService} from "../services/appointment.service";
import {Observable} from "rxjs";

@Injectable()
export class AppointmentResolver implements Resolve<any> {
  constructor(
    private appointmentService: AppointmentService
  ) {
  }

  public resolve(route: ActivatedRouteSnapshot): Observable<any> {
    console.log("Resolving appointment for " + route.params['id']);
    return this.appointmentService.getAppointment(route.params['id'], route.params['factoryId'], route.params['language']);
  }
}
